import { useEffect, useState } from 'react'
import axios from 'axios'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

//import { maintenanceState } from '../stores/MaintenanceAtom'
import ConstList from '../utils/ConstList'
import Loading from '../component/Loading'
//import Maintenance from './Maintenance'
import LoginButton from '../component/LoginButton'
import { useAuth0 } from '@auth0/auth0-react'
import { AppBar, Toolbar, Box, Typography, Paper } from "@mui/material";
// import { LoginUserAtom } from '../stores/LoginUserAtom'

import WorkHistoryIcon from '@mui/icons-material/WorkHistory'; // 営業履歴のアイコン追加


// 色を指定しています
import theme from '../theme'
import { ThemeProvider } from '@mui/material/styles';



function Login() {
  //Atom ユーザー一覧
  //const setMaintenance = useSetRecoilState(maintenanceState)

  const [loading, setLoading] = useState<boolean>(false)

  //const loginUserData = useRecoilValue(LoginUserAtom)

  //APIの際のURL
  const URL = ConstList.getApiUrl() + 'Get_Maintenance.php'
  //const userAuthority = loginUserData.Authority

  // // 現在のバージョンを取得し比較
  // useEffect(() => {
  //   ConstList.versionCheck()
  //   async function getMaintenance() {
  //     const response = await axios.get(
  //       ConstList.getApiUrl() + 'getMaintenance.php',
  //       ConstList.AXIOS_CONFIG
  //     )
  //     //setMaintenance(response.data)
  //   }
  //   getMaintenance()
  // }, [])

  //最初にメンテナンスフラグを取得
  // useEffect(() => {
  //   setLoading(true)

  //   const getMaintenance = async () => {
  //     try {
  //       //ユーザーリストの取得
  //       //authUserList(response.data.access_token)
  //       const DATA = {
  //         flag: 'getMaintenance',
  //         loginUser: userAuthority,
  //       }
  //       await axios
  //         .post(URL, DATA)
  //         .then((response) => {
  //           console.log(response.data)

  //           // Recoilにセット
  //           setMaintenance((currentInput: any) => ({
  //             ...currentInput,

  //             maintenance: response.data[1][0],
  //           }))

  //           setLoading(false)
  //         })
  //         .catch((error) => {
  //           console.log('エラー')
  //           console.log(error)
  //           //エラー
  //           setLoading(false)
  //           alert(error)
  //         })

  //       //メタデータの取得API(自作API)
  //     } catch (e) {
  //       if (e instanceof Error) {
  //         //errorがErrorクラスである場合messageがフィールドに含まれることが保証されるので型安全
  //         alert(e.message)
  //       } else if (typeof e === 'string') {
  //         alert(e)
  //       } else {
  //         alert('unexpected error')
  //       }

  //       // Recoilにセット
  //       setMaintenance((currentInput: any) => ({
  //         ...currentInput,

  //         maintenance: false,
  //       }))
  //       setLoading(false)
  //       console.log(e)

  //       //alert('エラー：リロードまたは、再ログインを行ってください。')
  //     }
  //   }

  //   getMaintenance()
  // }, [])

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #2c3e50, #3A414C)", // 車両管理らしい青系
      }}
    >
    <ThemeProvider theme={theme}>
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: 350,
          textAlign: "center",
          borderRadius: "10px",
          background: "secondary",
        }}
      >
        <WorkHistoryIcon sx={{ fontSize: 50, color: 'primary.main', mb: 1 }} />
       <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold", color: 'text.main' }}>
          営業情報管理システム
        </Typography>

        <Box sx={{ my: 1 }}>
          <LoginButton />
        </Box>
      </Paper>
    </ThemeProvider>
    </Box>
  );
}





export default Login
